export const RESET = 'INCOTERM_LIST_RESET'
export const SET_ITEMS = 'INCOTERM_LIST_SET_ITEMS'
export const SET_ERROR = 'INCOTERM_LIST_SET_ERROR'
export const SET_VIEW = 'INCOTERM_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'INCOTERM_LIST_TOGGLE_LOADING'
